import ApiServiceAssesments from "../apiServiceAssesments.js";

const querystring = require("querystring");
var CandidateProfileService = {
  findAll: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "candidateProfile";
      $options.method = "get";

      if ($data) {
        $options.url = "candidateProfile?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findScheduleDetails: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getScheduleDetails";
      $options.method = "get";

      if ($data) {
        $options.url = "getScheduleDetails?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findList: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "dsCandidateProfile";
      $options.method = "get";

      if ($data) {
        $options.url = "dsCandidateProfile?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCampusList: function($data){
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getCampusList";
      $options.method = "get";

      if ($data) {
        $options.url = "getCampusList?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findSelectedCandidate: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "getSelectedCandidate";
      $options.method = "get";

      if ($data) {
        $options.url = "getSelectedCandidate?" + querystring.stringify($data);
        console.log($options.url, "asss");
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          console.log("test");
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  findOne: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.url = "candidateProfile/" + $data.id;
      console.log($options.url);
      $options.method = "get";
      if (!$data) {
        $options.data = $data;
      }
      ApiServiceAssesments.request($options)
        .then((response) => {
          // console.log('Gpt the data');
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update: function($data) {
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.data = $data;
      $options.url = "candidateProfile/" + $data.id;
      $options.method = "post";
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  bulkUpdate : function($data){
    return new Promise(function(resolve, reject) {
      let $options = {};
      $options.data = $data
      $options.url = "bulkUpdate"
      $options.method = "post"
      ApiServiceAssesments.request($options)
            .then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error)
            });
    })
  },
  uploadCsv: function($data) {
    return new Promise(function(resolve, reject) {
        let $options = {};
        $options.data = $data
        $options.url = "uploadCPData" // uploadIssue
        $options.method = "post"
        console.log($options)
        ApiServiceAssesments.request($options)
            .then(response => {
                resolve(response.data.data)
            }).catch(error => {
                reject(error)
            });
    })
},
  save: function($data) {
    return new Promise(function(resolve, reject) {
      var $options = {};
      $options.data = $data;
      $options.url = "candidateProfile" + $data.id;
      $options.method = "post";
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create: function($data) {
    return new Promise(function(resolve, reject) {
      var $options = {};
      $options.data = $data;
      $options.url = "candidateProfile";
      $options.method = "post";
      $options.data = $data
      console.log($options);
      ApiServiceAssesments.request($options)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
    });
    });
  },
};
export default CandidateProfileService;
